var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cpage-meta\u003ERegister as an investor\u003C\u002Fpage-meta\u003E\u003Centity-name value=\"\"\u003E\u003C\u002Fentity-name\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cmd-card layout-padding\u003E\u003Cdiv id=\"progress\" layout=\"row\"\u003E\u003Cnumbered-step class=\"registration\" step=\"1\" state=\"{{vm.registrationStep.state}}\" title=\"{{vm.registrationStep.title}}\" subtitle=\"{{vm.registrationStep.subtitle}}\" complete=\"vm.isRegistered()\" incomplete-message=\"Unverified\" visited=\"true\"\u003E\u003C\u002Fnumbered-step\u003E\u003Cnumbered-step class=\"{{form.name}}\" ng-repeat=\"form in vm.applicationForms\" step=\"{{$index + 2}}\" no-handle=\"$index === vm.applicationForms.length\" disabled=\"!vm.identityCheckAttempted()\" state=\"{{form.state}}\" title=\"{{form.title}}\" subtitle=\"{{form.subtitle}}\" complete=\"vm.isFormComplete(form)\" visited=\"vm.formVisited(form)\"\u003E\u003C\u002Fnumbered-step\u003E\u003Cnumbered-step class=\"{{form.name}}\" step=\"3\" no-handle=\"true\" disabled=\"!vm.identityCheckAttempted()\" state=\"{{vm.consentStep.state}}\" title=\"{{vm.consentStep.title}}\" subtitle=\"{{vm.consentStep.subtitle}}\" complete=\"vm.isFormComplete(form)\" visited=\"vm.formVisited(form)\"\u003E\u003C\u002Fnumbered-step\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-card\u003E\u003Cmd-card\u003E\u003Cmd-progress-linear ng-if=\"vm.submitting\" md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003Cmd-progress-linear ng-if=\"!vm.formTracker\" md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003Cmd-card-content\u003E\u003Cui-view\u003E\u003C\u002Fui-view\u003E\u003C\u002Fmd-card-content\u003E\u003Cdiv class=\"bottom\" ng-if=\"vm.identityCheckAttempted()\"\u003E\u003Chr\u003E\u003Cdiv id=\"action\" layout=\"row\" layout-align=\"space-between start\" layout-margin\u003E\u003Cmd-button class=\"previous md-raised md-primary\" ng-click=\"vm.investorApplicationRouter.previous()\" type=\"button\" ng-if=\"vm.investorApplicationRouter.hasPrevious\"\u003EPrevious\u003C\u002Fmd-button\u003E\u003Cdiv class=\"filler\" ng-if=\"!vm.investorApplicationRouter.hasPrevious\" flex\u003E\u003C\u002Fdiv\u003E\u003Cmd-button class=\"next md-raised md-accent\" ng-click=\"vm.investorApplicationRouter.next()\" type=\"button\" ng-if=\"vm.investorApplicationRouter.hasNext &amp;&amp; vm.investorApplicationRouter.hasPrevious\"\u003ENext\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"skip md-raised md-primary\" ng-click=\"vm.investorApplicationRouter.next()\" type=\"button\" ng-if=\"vm.investorApplicationRouter.hasNext &amp;&amp; !vm.investorApplicationRouter.hasPrevious\"\u003ESkip ID Verification\u003C\u002Fmd-button\u003E\u003Cform class=\"submit-application\" api-form=\"vm.submit()\" ng-if=\"!vm.investorApplicationRouter.hasNext\"\u003E\u003Cmd-button class=\"md-raised md-accent submit\" type=\"submit\" ng-disabled=\"!vm.validForSubmit()\" aria-label=\"Submit application\" ga-click=\"application.applyinvestor-submit\"\u003ESubmit application\u003C\u002Fmd-button\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-card\u003E";
}
});}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;